import { Link } from "react-router-dom"

import { SESSION_TYPE } from "modules/Booking/common/constants"
import { BrowserWarningBanner, BrowserWarningType } from "components/BrowserWarningBanner"
import { AdviceBlockDiscount, TelegramBlock } from "components"
import { isGetBookingDetailsResponse } from "modules/BookingCommon/common/utils"
import { useClientContext } from "modules/ClientAuthorization/common/ClientContext"
import {
    createdBookingLoader,
    createdDepositLoader,
    paidBookingLoader,
} from "modules/BookingCommon/common/queries"
import { UserInfoPageHash } from "modules/ClientAccount"
import { GiftCertificateBanner } from "modules/BookingCommon/components"
import { Spinner } from "components/Spinner"
import { SessionDetails, SessionInfoCard } from "modules/Booking/AfterPaymentPage/components"
import style from "modules/Booking/AfterPaymentPage/deposit.module.scss"
import { useBannerSettings } from "utils/Banners/useBannerSettings"
import { SESSION_LENGTH } from "utils/env-management"
import { TextWithIcon } from "ui-kit/components-branded/Text"
import { Img } from "ui-kit/components-branded/Img"

export function DepositSession() {
    const depositHash = createdDepositLoader.getHash()
    const depositQuery = createdDepositLoader.useGet(depositHash)

    const paidBookingQuery = paidBookingLoader.useGet(depositQuery?.data?.bookings[0])
    const paidBookingDetails = paidBookingQuery.data
    const bookingQuery = createdBookingLoader.useGet(depositQuery?.data?.bookings[0])
    const bookingDetails = bookingQuery.data

    const [{ userAccount }] = useClientContext()
    const { isShowTelegramBanner } = useBannerSettings()
    const isFetched = depositQuery.isFetched && paidBookingQuery.isFetched
    const isError = paidBookingQuery.isError || depositQuery.isError

    return (
        <div className="redesign-container">
            {isFetched && isGetBookingDetailsResponse(paidBookingDetails) ? (
                <div className="after-payment">
                    {isError ? (
                        <div>
                            Ошибка. Перезагрузите страницу, а&nbsp;если не&nbsp;помогло,
                            то&nbsp;обратитесь в&nbsp;службу поддержки
                        </div>
                    ) : (
                        <>
                            <div className="after-payment__left">
                                <SessionDetails
                                    sessionType={SESSION_TYPE.DEFAULT}
                                    phone={paidBookingDetails.client_phone}
                                    email={paidBookingDetails.client_email}
                                />
                                <div className={style.banner}>
                                    <TextWithIcon
                                        icon={
                                            <Img src="calendar.png" className={style.bannerEmoji} />
                                        }
                                        position="left"
                                    >
                                        Чтобы записаться на&nbsp;следующие сессии с&nbsp;этим
                                        психологом,&nbsp;
                                        <Link to="/my/alter">перейдите в&nbsp;Мой Alter.</Link>
                                    </TextWithIcon>
                                </div>
                                {paidBookingDetails.psy.experiment_group &&
                                    paidBookingDetails.is_online && (
                                        <BrowserWarningBanner
                                            type={BrowserWarningType.Session}
                                            className="after-payment__browser-waring"
                                        />
                                    )}
                                {isShowTelegramBanner && !userAccount.telegram_account && (
                                    <TelegramBlock
                                        button={
                                            <Link
                                                className="button-primary is-inline-block telegramButton w-100 text-center"
                                                to={`/my/userinfo#${UserInfoPageHash.TELEGRAM_ACCOUNT}`}
                                            >
                                                Подключить
                                            </Link>
                                        }
                                    />
                                )}
                                <SessionInfoCard
                                    title="Информация о первой сессии"
                                    sessionType={SESSION_TYPE.DEFAULT}
                                    psy={paidBookingDetails.psy}
                                    serviceType={paidBookingDetails.service_type}
                                    isOnline={paidBookingDetails.is_online}
                                    psyPhone={paidBookingDetails.psy_phone}
                                    psyFullName={paidBookingDetails.psy_full_name}
                                    price={paidBookingDetails.price}
                                    priceUsd={paidBookingDetails.price_usd}
                                    paymentSystem={paidBookingDetails.payment_system}
                                    rfc3339_start_datetime={
                                        paidBookingDetails.rfc3339_start_datetime
                                    }
                                    durationMinutes={
                                        bookingDetails?.duration_minutes ||
                                        SESSION_LENGTH.toString()
                                    }
                                    callEnabled={paidBookingDetails.psy.experiment_group}
                                    lobbyLink={`/my/call/lobby/${depositQuery?.data?.bookings[0]}`}
                                />
                                {userAccount.allowed_referral_program && (
                                    <AdviceBlockDiscount className="after-payment__last-widget is-booking" />
                                )}
                            </div>
                            <div className="after-payment__banners">
                                <GiftCertificateBanner />
                            </div>
                        </>
                    )}
                </div>
            ) : (
                <Spinner />
            )}
        </div>
    )
}
